import React from 'react'
import ModalBody from 'components/Utils/Modal/Body'
import ChannelPermissionsForm from './ChannelPermissionsForm'

export type ChannelsSettingsUsersProps = {
  channelId: string
}

export default function ChannelsSettingsUsers({
  channelId,
}: ChannelsSettingsUsersProps) {
  return (
    <ModalBody>
      <ChannelPermissionsForm channelId={channelId} />
    </ModalBody>
  )
}
